/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  display: flex;
  position: relative;  
  justify-content: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

/**
 * Estilização do componente MenuTools
 */
export const MenuTools = styled.div`
  min-height: 40px;
  /* max-width: 107px;   */
  background: ${({ theme }) => theme.primaryColorDark};
  display: none;  
  text-align: center;  
  margin-top: 42px;  
  z-index: 1600;
  box-shadow: 0 1px 5px rgba(0,0,0,0.5) inset;

  &.active {
    display: flex;
    position: fixed;
    @media (max-width: 768px) {
      display: none;
    }
  }

  .tool {
    background: none;
    border: none;
    text-decoration: none;
    color: #797e82;    

    .a-icon {
      &.disabled {
        path {
          fill: #b6b6b6;
        }
      }
    }

    button {
      height: 40px;
    }

    .disabled {
      color: #b6b6b6;
    }

    .MuiSvgIcon-fontSizeSmall {
      font-size: 1rem;
    }
  }  
`;
